import { LifecycleLatencyStats } from "../../../types/LifecycleLatencyStats";
import { LifecycleActionKey } from "../../actions/ActionKeys";
import { LifecycleChangeAction } from "../../actions/lifecycle";

export const lifecycle = (
  state: LifecycleLatencyStats = {},
  action: LifecycleChangeAction
): LifecycleLatencyStats => {
  switch (action.type) {
    case LifecycleActionKey.LIFECYCLE_CHANGE_OCCURRED:
      // We don't want to overwrite existing report information, so just fallthrough
      // in the case that we're getting subsequent events, for example if we hide and
      // reshow the iframe, we don't want to count that as part of the startup lifecycle.
      if (state[action.payload.lifecycleStage]) {
        return state;
      }
      return {
        ...state,
        [action.payload.lifecycleStage]: action.payload.timing,
      };
    default:
      return state;
  }
};
